export default class OffrePropositionRemiseModalController {
	static $inject = ['$state', '$stateParams', 'notification', '$translate'];

	constructor($state, $stateParams, notification, $translate) {
		this.$state = $state;
		this.$stateParams = $stateParams;
		this.$translate = $translate;
		this.notification = notification;
		this.produit = {};
		this.remiseValeur = 0;
		this.prixApplique = 0;
		this.prixOrigine = 0;
		this.remiseType = '0';
	}

	async $onInit() {
		this.produit = this.resolve.produit;
		this.prixApplique = this.produit.prixVente;
		this.remiseValeur = this.produit.remiseValeur;

		// Cast booléen pour éliminer null/undefined/0
		this.prixOrigine = this.produit.prixOrigine ?? this.produit.prixVente;

		this.remiseType = `${this.produit.remiseType}`;
		this.calculerRemise();
		console.log('PRODUIT In', this.produit);
	}

	formatValue(value) {
		if (Number.isInteger(value)) {
			return value;
		} else {
			return parseFloat(value.toFixed(2));
		}
	}

	async calculerRemise() {
		this.remiseValeur = parseFloat(this.remiseValeur);
		this.prixOrigine = parseFloat(this.prixOrigine);

		let valeur = this.remiseValeur;

		switch (this.remiseType) {
			case '2': // Remise en %
				valeur = Math.min(Math.max(valeur, 0), 100);
				this.prixApplique = this.formatValue(this.prixOrigine * (1 - valeur / 100));
				break;

			case '1': // Remise en €
				valeur = Math.min(Math.max(valeur, 0), this.prixOrigine);
				this.prixApplique = this.formatValue(this.prixOrigine - valeur);
				break;

			default: // Prix negocié
				valeur = Math.min(Math.max(valeur, 0), this.prixOrigine);
				this.prixApplique = this.formatValue(valeur);
				break;
		}

		this.remiseValeur = valeur;
	}

	ok() {
		this.produit.remiseType = Number(this.remiseType);
		this.produit.prixVente = this.prixApplique;
		this.produit.remiseValeur = this.remiseValeur;
		this.produit.prixOrigine = this.prixOrigine;
		console.log('PRODUIT Out', this.produit);
		this.modalInstance.close(this.produit);
	}

	supprimerRemise() {
		this.produit.remiseType = 0;
		this.produit.remiseValeur = 0;
		this.produit.prixVente = this.produit.prixOrigine;
		this.modalInstance.close(this.produit);
	}

	close() {
		this.modalInstance.close();
	}
}
